<template>
  <div
    class="navbar d-flex align-items-center bg-color-primary pos-fixed px-150 z-index-10 x-large:px-300"
    id="navbar"
  >
    <div class="navbar__logo h-100 mr-auto">
      <a class="h-100 d-block py-100" href="#top" aria-label="Return to top">
        <img
          class="d-block"
          src="@/assets/navigation/desktop/nav_logo.png"
          height="100%"
          alt="The Fan Exam"
        />
      </a>
    </div>
    <div class="navbar__menu c-menu ml-300 x-large:align-self-stretch">
      <button
        class="c-menu__toggle reset flex-center mr-150 cursor-pointer text-on-primary x-large:d-none"
        type="button"
        aria-label="Toggle menu"
        @click="toggle_menu()"
      >
        <svg
          class="c-menu__toggle-menu"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <title>Menu icon</title>
          <path
            fill="#000"
            fill-rule="evenodd"
            d="M5.5 6c0-.27614.22386-.5.5-.5h12c.2761 0 .5.22386.5.5s-.2239.5-.5.5H6c-.27614 0-.5-.22386-.5-.5zm0 6c0-.2761.22386-.5.5-.5h12c.2761 0 .5.2239.5.5s-.2239.5-.5.5H6c-.27614 0-.5-.2239-.5-.5zm.5 5.5c-.27614 0-.5.2239-.5.5s.22386.5.5.5h12c.2761 0 .5-.2239.5-.5s-.2239-.5-.5-.5H6z"
            clip-rule="evenodd"
          />
          <mask
            id="a"
            width="14"
            height="14"
            x="5"
            y="5"
            maskUnits="userSpaceOnUse"
          >
            <path
              fill="#000"
              fill-rule="evenodd"
              d="M5.5 6c0-.27614.22386-.5.5-.5h12c.2761 0 .5.22386.5.5s-.2239.5-.5.5H6c-.27614 0-.5-.22386-.5-.5zm0 6c0-.2761.22386-.5.5-.5h12c.2761 0 .5.2239.5.5s-.2239.5-.5.5H6c-.27614 0-.5-.2239-.5-.5zm.5 5.5c-.27614 0-.5.2239-.5.5s.22386.5.5.5h12c.2761 0 .5-.2239.5-.5s-.2239-.5-.5-.5H6z"
              clip-rule="evenodd"
            />
          </mask>
        </svg>
        <svg
          class="c-menu__toggle-close"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <title>Close icon</title>
          <path
            fill="#000"
            fill-rule="evenodd"
            d="M18.3802 6.19835c.1598-.15976.1598-.41877 0-.57853s-.4188-.15976-.5785 0L12 11.4215 6.19835 5.61982c-.15976-.15976-.41877-.15976-.57853 0s-.15976.41878 0 .57853L11.4215 12l-5.80166 5.8016c-.15976.1598-.15976.4188 0 .5786.15976.1597.41877.1597.57853 0L12 12.5785l5.8016 5.8017c.1598.1597.4188.1597.5786 0 .1597-.1598.1597-.4188 0-.5785L12.5785 12l5.8017-5.80165z"
            clip-rule="evenodd"
          />
          <mask
            id="a"
            width="14"
            height="14"
            x="5"
            y="5"
            maskUnits="userSpaceOnUse"
          >
            <path
              fill="#000"
              fill-rule="evenodd"
              d="M18.3802 6.19835c.1598-.15976.1598-.41877 0-.57853s-.4188-.15976-.5785 0L12 11.4215 6.19835 5.61982c-.15976-.15976-.41877-.15976-.57853 0s-.15976.41878 0 .57853L11.4215 12l-5.80166 5.8016c-.15976.1598-.15976.4188 0 .5786.15976.1597.41877.1597.57853 0L12 12.5785l5.8016 5.8017c.1598.1597.4188.1597.5786 0 .1597-.1598.1597-.4188 0-.5785L12.5785 12l5.8017-5.80165z"
              clip-rule="evenodd"
            />
          </mask>
        </svg>
      </button>
      <ul class="c-menu__list reset-list x-large:d-flex text-align-center">
        <li class="c-menu__item" v-for="(item, index) in menu" :key="index">
          <a
            class="c-menu__link text-on-dark x-large:text-on-light text-decoration-none text-transform-uppercase font-weight-500 d-flex align-items-center px-150 py-300 x-large:px-150 x-large:py-0"
            :href="item.url"
            @click="
              close_menu();
              return true;
            "
          >
            <span>{{ item.title }}</span>
            <svg
              class="ml-auto x-large:d-none"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              fill="none"
              viewBox="0 0 24 25"
              aria-hidden="true"
            >
              <title>Arrow down icon</title>
              <path
                fill="#fff"
                fill-rule="evenodd"
                d="M18.169 9.85326c.1952-.19526.1952-.51185 0-.70711-.1953-.19526-.5119-.19526-.7071 0l-5.304 5.30395-5.30389-5.30395c-.19526-.19526-.51184-.19526-.7071 0-.19527.19526-.19527.51184 0 .70711l5.65229 5.65224c.0017.0018.0034.0035.0052.0053.1018.1018.2366.1505.37.1462.1224-.004.2437-.0528.3371-.1462.0017-.0017.0034-.0034.005-.0051l5.6525-5.65244z"
                clip-rule="evenodd"
              />
              <mask
                id="a"
                width="13"
                height="7"
                x="6"
                y="9"
                maskUnits="userSpaceOnUse"
              >
                <path
                  fill="#fff"
                  fill-rule="evenodd"
                  d="M18.169 9.85326c.1952-.19526.1952-.51185 0-.70711-.1953-.19526-.5119-.19526-.7071 0l-5.304 5.30395-5.30389-5.30395c-.19526-.19526-.51184-.19526-.7071 0-.19527.19526-.19527.51184 0 .70711l5.65229 5.65224c.0017.0018.0034.0035.0052.0053.1018.1018.2366.1505.37.1462.1224-.004.2437-.0528.3371-.1462.0017-.0017.0034-.0034.005-.0051l5.6525-5.65244z"
                  clip-rule="evenodd"
                />
              </mask>
            </svg>
          </a>
        </li>
        <li class="c-menu__item">
          <a
            class="c-menu__link text-on-dark x-large:text-on-light text-decoration-none text-transform-uppercase font-weight-500 d-flex align-items-center px-150 py-300 x-large:px-150 x-large:py-0"
            :href="rules_url"
          >
            <span>Rules &amp; Regulations</span>
          </a>
        </li>
        <li class="c-menu__social-links x-large:d-none">
          <social />
        </li>
      </ul>
    </div>
    <a
      class="navbar__play-button button text-align-center white-space-nowrap x-large:ml-150"
      href="#game"
    >
      <span class="d-none medium:d-inline-block">Play Now</span>
      <span class="medium:d-none">Play</span>
    </a>
    <div
      class="navbar__social d-none ml-200 x-large:d-block xx-large:ml-300"
    >
      <social />
    </div>
  </div>
</template>

<script>
import Social from "@/components/Social";
export default {
  name: "Navbar",

  components: {
    Social,
  },

  props: ["rules_url"],

  data() {
    return {
      menu: [
        {
          title: "What is The Fan Exam?",
          url: "#howToPlay",
        },
      ],
    };
  },

  methods: {
    toggle_menu() {
      if (
        document.querySelector("body").classList.contains("main-menu-active")
      ) {
        this.close_menu();
      } else {
        this.open_menu();
      }
    },

    close_menu() {
      document.querySelector("body").classList.remove("main-menu-active");
    },

    open_menu() {
      document.querySelector("body").classList.add("main-menu-active");
    },
  },

  mounted() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function(e) {
        e.preventDefault();
        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth",
        });
      });
    });
  },
};
</script>

<style lang="scss">
.navbar {
  height: 60px;
  top: 0;
  left: 0;
  width: 100%;
}

.c-menu {
  &__toggle {
    height: 24px;
    width: 24px;
  }
  &__link {
    font-size: 0.875rem;

    > span {
      padding: 2px 0;
      transition: all 0.15s;
    }

    &:hover,
    &:focus {
      > span {
        box-shadow: inset 0 -2px 0 var(--color-secondary);
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .c-menu {
    &__list {
      background-color: var(--color-black);
      left: -99999px;
      max-height: calc(100vh - 60px);
      position: absolute;
      top: 100%;
      width: 100%;

      body.main-menu-active & {
        left: 0;
      }
    }

    &__toggle {
      &-menu {
        display: block;
      }
      &-close {
        display: none;
      }

      body.main-menu-active & {
        &-menu {
          display: none;
        }
        &-close {
          display: block;
        }
      }
    }

    &__item {
      border-top: 1px solid var(--color-dark);

      &:first-child {
        border: none;
      }
    }

    &__social-links {
      border-top: 1px solid var(--color-dark);
    }
  }
}

@media screen and (min-width: 1024px) {
  .c-menu {
    &__list {
      height: 100%;
    }

    &__link {
      height: 100%;
    }
  }
}
</style>
